import '@style/common/main-style'

import '@style/common/button.css'
import '@style/common/breadcrumbs.css'
import '@style/components/template/Note/index.css'

import '@style/common/shiki.css'

import '@style/common/courseChapter/header.css'

import './index.css'

import '@comp/customHtml/Snackbar'

import '@core/components/template/breadcrumbs'

// import 'highlight.js/styles/tokyo-night-dark.css'
import '@core/utils/text.ts'

import { deletePage } from '@utils/browserTest.ts'
import { getUrlParams, updatePageTitle } from '@core/utils/url.ts'
import { loadChapterWithSlug } from '@service/chapters.ts'
import { loadCourseWithSlug } from '@service/courses.ts'
import { useChapter } from '@core/composables/useChapter.ts'
import { loadChapterLinks } from '@service/links.ts'
import { generateChapterElements } from '@core/views/chapter/generate.ts'
import { removeCurrentPageClickEvent } from '@core/components/template/breadcrumbs'

document.addEventListener('DOMContentLoaded', () => {
  deletePage().then(async () => {
    if (import.meta.env.DEV) {
      const params = getUrlParams(/\/course\/([a-z0-9-]+)\/chapter\/([a-z0-9-]+)|\/chapter\/([a-z0-9-]+)/)
      const courseSlug = params[0] !== 'undefined' ? params[0] : ''
      const chapterSlug = params[1] !== 'undefined' ? params[1] : params[2] || ''

      const [chapter, links] = await Promise.all([loadChapterWithSlug(chapterSlug), loadChapterLinks(chapterSlug)])

      let course
      if (courseSlug) {
        course = await loadCourseWithSlug(courseSlug)
      }

      updatePageTitle(`${chapter.title}`)
      generateChapterElements(document, chapter.title, course)

      const { initChapterHeader, initChapterBody, initChapterLinks, initSummary } = useChapter()
      initChapterHeader(document, chapter)
      initChapterBody(document, chapter)
      initSummary(
        document,
        chapter.summary ?? [],
        document.querySelector('body main > section > aside > nav:first-of-type')!,
      )
      initChapterLinks(document, links)
    }

    const linkCSS = document.getElementById('highlightStylesheet')!

    const colorSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const loadHighlightColors = async (isDark: boolean): Promise<void> => {
      const newLinkCSS = !isDark
        ? await import('highlight.js/styles/tokyo-night-light.css?inline')
        : await import('highlight.js/styles/tokyo-night-dark.css?inline')

      linkCSS.innerHTML = newLinkCSS.default
    }

    await loadHighlightColors(colorSchemeQuery.matches)

    colorSchemeQuery.addEventListener('change', (e) => {
      void loadHighlightColors(e.matches)
    })

    removeCurrentPageClickEvent()
  })
})
